export enum Permission {
  PLAN_MODULE = 'plan_module',
}
